import { render, staticRenderFns } from "./SaleReturnItem.vue?vue&type=template&id=2c52c62a&scoped=true&"
import script from "./SaleReturnItem.vue?vue&type=script&lang=js&"
export * from "./SaleReturnItem.vue?vue&type=script&lang=js&"
import style0 from "./SaleReturnItem.vue?vue&type=style&index=0&id=2c52c62a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c52c62a",
  null
  
)

export default component.exports